import { useState } from "react";
import { useAppContext } from "../../../../AppContext";
import { getCurrentUserRole } from "../../../../common/infrastructure/helpers/userHelper";
import { UserRole } from "../../../../common/enums";
import { useExpirationTab } from "./useExpirationTab";
import { useQuantityTab } from "./useQuantityTab";

export const useInventoryOverviewPage = () => {
  const [activeTabIndex, setActiveTabIndex] = useState(0);
  const { currentUser } = useAppContext();

  const role = getCurrentUserRole(currentUser);
  const canDestroy =
    role !== undefined &&
    role !== UserRole.User &&
    role !== UserRole.Employee_Instructor &&
    role !== UserRole.Employee_Instructor_Group_Events;

  const expirationTab = useExpirationTab(canDestroy);
  const quantityTab = useQuantityTab();

  return {
    activeTabIndex,
    setActiveTabIndex,
    canDestroy,
    expirationTab,
    quantityTab,
  };
};
